import React from "react";
import { Dropdown, Modal, Button, Spinner, Tabs, Tab } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Availability.scss";
import {
  faArrowUp,
  faCog,
  faPencilAlt,
  faPlus,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import useAvailability from "./useAvailability";
import { TIMEZONE } from "../../../Candidate/EditCandidateProfile/constants";
import { faEllipsisVertical } from "@fortawesome/free-solid-svg-icons/faEllipsisVertical";
import { faTrashAlt } from "@fortawesome/free-regular-svg-icons";

function Availability(props) {
  const {
    show,
    user,
    handleClose,
    availabilityList,
    availabilityDetail,
    editTitleActive,
    timeIntervals,
    dummyClickRef,
    onPanelChange,
    isCreateAvailabilityLoading,
    isDeleteLoading,
    loading,
    onFormInputChange,
    onEditTitle,
    onAvailabilityDelete,
    onIntervalAdd,
    onAvailabilityChange,
    onIntervalChange,
    onNewScheduleClick,
    onIntervalDelete,
    handleShow,
    onCreateAvailabilityTitle,
    onTimeZoneCick,
  } = useAvailability(props);

  const daysOfWeek = [
    "sunday",
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
  ];

  return (
    <div ref={dummyClickRef}>
      <div className="d-flex align-items-start justify-content-between">
        <div className="d-flex align-items-center mb-4 w-75">
          <div className="top">
            <h2 className="mb-2">Set your availability</h2>
            <p className="text-grey-4">
              Choose a schedule below to edit or create a new one that you can
              apply to your event types
            </p>
          </div>
        </div>
        <button
          className="btn btn-primary border-radius-10 d-flex align-items-center"
          onClick={handleShow}
        >
          <FontAwesomeIcon icon={faPlus} className="mr-md-2" />
          <span className="d-md-block d-none">New Schedule</span>
        </button>
      </div>

      <ul className="schedule-tab-list d-flex align-items-center flex-wrap mb-4 pb-2 border-bottom">
        {availabilityList?.results &&
          Array.isArray(availabilityList?.results) &&
          availabilityList.results.map((item) => (
            <li
              className={`btn mr-2 mb-2 border-radius-10 font-weight-semi text-capitalize
                      ${availabilityDetail?.id === item?.id
                  ? "btn-outline-primary"
                  : "btn-outline-dark"
                }`}
              onClick={() => onAvailabilityChange(item?.id)}
              key={item?.id}
            >
              {item?.title}
            </li>
          ))}
      </ul>

      {loading ? (
        <div className="d-flex justify-content-center align-items-center">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : Array.isArray(availabilityList?.results) &&
        availabilityList?.results.length ? (
        <div className="row  mb-5">
          <div className="col-lg-8 mb-3 order-2 order-md-1">
            <div className="calender-dashboard h-100  border bg-white border-radius-10 p-4">
              <div className="top d-flex align-items-center justify-content-between mb-2">
                {editTitleActive ? (
                  <div className="d-flex align-items-center flex-grow-1">
                    <input
                      type="text"
                      className="form-control text-capitalize"
                      defaultValue={availabilityDetail?.title}
                      onBlur={(e) => onFormInputChange(e)}
                      name="title"
                    />
                    <button
                      className="text-danger bg-transparent border-0 ml-2"
                      onClick={() => onEditTitle(false)}
                    >
                      <FontAwesomeIcon icon={faXmark} />
                    </button>
                  </div>
                ) : (
                  <h2 className="mb-0 text-capitalize">
                    {availabilityDetail?.title}
                  </h2>
                )}

                <Dropdown className="ml-3">
                  <Dropdown.Toggle variant="" className="p-0">
                    <FontAwesomeIcon icon={faEllipsisVertical} className="text-grey-4" />
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <ul className="py-1 px-3">
                      <li
                        className="d-flex align-items-center cursor-pointer"
                        onClick={() => onEditTitle(true)}
                      >
                        {" "}
                        <FontAwesomeIcon
                          icon={faPencilAlt}
                          className="mr-2 py-2 text-grey-4"
                        />
                        Edit
                      </li>
                      <li
                        className="d-flex align-items-center cursor-pointer"
                        onClick={() =>
                          onAvailabilityDelete(availabilityDetail?.id)
                        }
                      >
                        {" "}
                        <FontAwesomeIcon
                          icon={faTrashAlt}
                          className="text-danger mr-2 py-2 "
                        />
                        {isDeleteLoading ? <Spinner /> : "Delete"}
                      </li>
                    </ul>
                  </Dropdown.Menu>
                </Dropdown>
              </div>

              <Tabs defaultActiveKey="WeeklyHours">
                <Tab eventKey="WeeklyHours" title="Weekly Hours" className="p-0">
                  <div className="availability-wrapper pt-4 mb-5">
                    <div className="schedule-tab-content">
                      <div className="set-weekly-hours mt-4">
                        <div className="row">
                          <div className="col-md-8">
                            <div className="hours-list">
                              {daysOfWeek.map((days, dIndex) => (
                                <>
                                  <div
                                    className="set-hours d-flex align-items-center border-0"
                                    key={days}
                                  >
                                    <div className="custom-control custom-checkbox ">
                                      <input
                                        type="checkbox"
                                        className="custom-control-input"
                                        id={days}
                                      />
                                      <label
                                        className="custom-control-label font-weight-medium"
                                        htmlFor={days}
                                      ></label>
                                    </div>
                                    <span className="day">
                                      {days && days.slice(0, 3).toUpperCase()}
                                    </span>
                                    <div className="actions ml-auto d-flex align-items-center">
                                      <div
                                        className="span cursor-pointer"
                                        onClick={() => onIntervalAdd(days)}
                                      >
                                        <FontAwesomeIcon
                                          icon={faPlus}
                                          className="text-grey-4"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="time-selector-wrapper pl-4">
                                      {availabilityDetail &&
                                        Array.isArray(
                                          availabilityDetail?.local_time[days]
                                        ) &&
                                        availabilityDetail?.local_time[
                                          days
                                        ].map((interval, tIndex) => (
                                          <div
                                            className=" d-flex align-items-center time-selector justify-content-between mb-1"
                                            key={tIndex}
                                          >
                                            <div className="date-input position-relative">
                                              <Dropdown>
                                                <Dropdown.Toggle
                                                  variant=""
                                                  className="form-control border h-auto py-1"
                                                >
                                                  {interval?.start_time && interval.start_time.slice(0, 5)}
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu>
                                                  {Array.isArray(
                                                    timeIntervals
                                                  ) &&
                                                    timeIntervals.map(
                                                      (item, index) => (
                                                        <Dropdown.Item
                                                          onClick={(e) =>
                                                            onIntervalChange(
                                                              item,
                                                              "start_time",
                                                              days,
                                                              tIndex
                                                            )
                                                          }
                                                          key={index}
                                                        >
                                                          {item.slice(0, 5)}
                                                        </Dropdown.Item>
                                                      )
                                                    )}
                                                </Dropdown.Menu>
                                              </Dropdown>
                                            </div>
                                            <span className="divider">-</span>
                                            <div className="date-input position-relative">
                                              <Dropdown>
                                                <Dropdown.Toggle
                                                  variant=""
                                                  className="form-control border h-auto py-1"
                                                >
                                                  {interval?.end_time && interval.end_time.slice(0, 5)}
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu>
                                                  {Array.isArray(
                                                    timeIntervals
                                                  ) &&
                                                    timeIntervals.map(
                                                      (item, index) => (
                                                        <Dropdown.Item
                                                          onClick={(e) =>
                                                            onIntervalChange(
                                                              item,
                                                              "end_time",
                                                              days,
                                                              tIndex
                                                            )
                                                          }
                                                          key={index}
                                                        >
                                                          {item.slice(0, 5)}
                                                        </Dropdown.Item>
                                                      )
                                                    )}
                                                </Dropdown.Menu>
                                              </Dropdown>
                                            </div>
                                            <div className="d-flex align-items-center">
                                              <FontAwesomeIcon
                                                icon={faXmark}
                                                className="text-grey-4 cursor-pointer"
                                                onClick={() =>
                                                  onIntervalDelete(days, tIndex)
                                                }
                                              />
                                            </div>
                                          </div>
                                        ))}
                                    </div>
                                </>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Tab>
              </Tabs>
            </div>
          </div>
          <div className="col-lg-4 order-1 order-md-2">
            <div className="form-group">
              <p className="font-weight-medium">Time Zone</p>
              <div
                className="form-control bg-transparent text-capitalize"
                // onClick={onTimeZoneCick}
              >
                {user?.timezone}
              </div>
            </div>
            {/* =========for future use ========*/}
            {/* <p className="fs-14 text-muted">
              For updating timezone you have to click above
              <FontAwesomeIcon icon={faArrowUp} className="ml-2" />
            </p> */}
          </div>
        </div>
      ) : (
        <div className="d-flex align-items-center flex-column">
          {" "}
          <h3 className="mb-3">No Availability Found</h3>
          <button
            className="btn btn-primary border-radius-10"
            onClick={handleShow}
          >
            <FontAwesomeIcon icon={faPlus} className="mr-2" />
            New Schedule
          </button>
        </div>
      )}

      {/* <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Modal heading</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="site-calendar-demo-card">
            <Calendar fullscreen={false} onPanelChange={onPanelChange} />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleClose}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal> */}

      <Modal
        size="md"
        show={show}
        onHide={handleClose}
        centered
        className="border-radius-10"
      >
        <Modal.Body>
          <h2 className="border-bottom pb-3">New Schedule</h2>
          {availabilityDetail ? (
            <div className="schedule-tab-content mt-4">
              <p className="text-grey-4">Schedule Title</p>
              <div className="d-flex align-items-center justify-content-between mb-3">
                <input
                  type="text"
                  className="form-control rounded-lg"
                  placeholder="Working Hours, Exclusive Hours,..."
                  name="title"
                  onBlur={(e) => onCreateAvailabilityTitle(e)}
                />
              </div>
              <div className="border-top pt-4 d-flex justify-content-between align-items-center">
                <Button
                  variant=""
                  onClick={handleClose}
                  className="flex-1 px-5 btn btn-outline-dark border-radius-10"
                >
                  Cancel
                </Button>
                <Button
                  variant="primary"
                  onClick={onNewScheduleClick}
                  className="px-5 border-radius-10"
                >
                  {isCreateAvailabilityLoading ? <Spinner /> : "Create"}
                </Button>
              </div>
            </div>
          ) : null}
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default Availability;
